import { IconProps } from '../icon-props-interface';
import '../icons.scss';


export const IconLocation = ({ color = 'var(--color-neutral-10)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 16C6 16 12 9.5 12 6C12 2.6875 9.3125 0 6 0C2.6875 0 0 2.6875 0 6C0 9.5 6 16 6 16ZM6 4C6.53043 4 7.03914 4.21071 7.41421 4.58579C7.78929 4.96086 8 5.46957 8 6C8 6.53043 7.78929 7.03914 7.41421 7.41421C7.03914 7.78929 6.53043 8 6 8C5.46957 8 4.96086 7.78929 4.58579 7.41421C4.21071 7.03914 4 6.53043 4 6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4Z" fill={color}/>
        </svg>
    </div>
);

export default IconLocation;
